import { ApiProperty } from "@nestjs/swagger";
import { IsOptional } from "class-validator";

export class DriverJobDto {
    @ApiProperty()
    plantId: number;
    @ApiProperty()
    palletId: number;
    @ApiProperty()
    currentPosition: number;
    @ApiProperty()
    @IsOptional()
    machineName?: string;
    @ApiProperty()
    @IsOptional()
    OperatorName?: string;
    @ApiProperty()
    updatedAt: Date;  
    @ApiProperty()
    userName: string;    
  }
